/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Ai_Actions_EmptyInputs */

const en_settings_ai_actions_empty = /** @type {(inputs: Settings_Ai_Actions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No AI actions remaining. Upgrade to continue generating.`)
};

const de_settings_ai_actions_empty = /** @type {(inputs: Settings_Ai_Actions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine KI-Aktionen mehr übrig. Upgrade, um weiter zu generieren.`)
};

const fr_settings_ai_actions_empty = /** @type {(inputs: Settings_Ai_Actions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus d'actions IA disponibles. Passe à un plan supérieur pour continuer à générer.`)
};

const es_settings_ai_actions_empty = /** @type {(inputs: Settings_Ai_Actions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No quedan Acciones IA. Mejore su plan para continuar generando.`)
};

const it_settings_ai_actions_empty = /** @type {(inputs: Settings_Ai_Actions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna azione AI rimanente. Aggiorna per continuare a generare.`)
};

const nl_settings_ai_actions_empty = /** @type {(inputs: Settings_Ai_Actions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen AI-acties meer over. Upgrade om door te gaan met genereren.`)
};

const pl_settings_ai_actions_empty = /** @type {(inputs: Settings_Ai_Actions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak pozostałych akcji AI. Ulepsz, aby kontynuować generowanie.`)
};

const fi_settings_ai_actions_empty = /** @type {(inputs: Settings_Ai_Actions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei enää AI-toimintoja jäljellä. Päivitä jatkaaksesi generointia.`)
};

const da_settings_ai_actions_empty = /** @type {(inputs: Settings_Ai_Actions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen AI-handlinger tilbage. Opgrader for at fortsætte med at generere.`)
};

const sv_settings_ai_actions_empty = /** @type {(inputs: Settings_Ai_Actions_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga AI-aktioner kvar. Uppgradera för att fortsätta generera.`)
};

/**
* | output |
* | --- |
* | "No AI actions remaining. Upgrade to continue generating." |
*
* @param {Settings_Ai_Actions_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_ai_actions_empty = /** @type {((inputs?: Settings_Ai_Actions_EmptyInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Ai_Actions_EmptyInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_ai_actions_empty(inputs)
	if (locale === "fr") return fr_settings_ai_actions_empty(inputs)
	if (locale === "es") return es_settings_ai_actions_empty(inputs)
	if (locale === "it") return it_settings_ai_actions_empty(inputs)
	if (locale === "nl") return nl_settings_ai_actions_empty(inputs)
	if (locale === "pl") return pl_settings_ai_actions_empty(inputs)
	if (locale === "fi") return fi_settings_ai_actions_empty(inputs)
	if (locale === "da") return da_settings_ai_actions_empty(inputs)
	if (locale === "sv") return sv_settings_ai_actions_empty(inputs)
	return en_settings_ai_actions_empty(inputs)
});